export default __webpack_public_path__ + "static/media/favicon.71b2b1dd.ico";